import styles from "./panel.module.css";

interface PanelProps {
  title: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
}

function Panel(props: PanelProps) {
  const render = () => {
    return (
      <div className={styles["panel"]}>
        <div className={styles["header"]}>
          <div className={styles["title-container"]}>
            {props.icon && <div className={styles["icon"]}>{props.icon}</div>}
            <div className={styles["title"]}>{props.title}</div>
          </div>
        </div>
        <div className={styles["content"]}>{props.children}</div>
      </div>
    );
  };

  return render();
}

export default Panel;
